// 安装axios
// $cnpm i axios -S

import axios from "axios";
// 创建axios初始化
// https://apis.netstart.cn/music/user/followeds?uid=32953014
const service = axios.create({
    
    // baseURL: "https://apis.netstart.cn",
    baseURL: localStorage.getItem("baseURL"),
    timeout: 5400000, //超时时间
    headers: {
        "Content-Type": "application/json;charset=utf-8", //表单数据转化
    },
    withCredentials: true,
});


// request 拦截器 发送数据到后台前拦截
service.interceptors.request.use(
    (config) => {
        const d = localStorage.getItem('userDetailed');
        if (d) {
          let t = JSON.parse(d);
          config.headers['token'] = t.pkid;
          // config.headers['content-type'] = 'application/vnd.ms-excel';
        }
        return config;
    },
    (error) => {
        console.log("axios中request报错", error);
        Promise.reject(error);
    }
);


// response 拦截器 获取后台数据前拦截
service.interceptors.response.use(
    (response) => {
        return response.data;
    },
    (error) => {
        console.log("axios中response报错", error);
        Promise.reject(error);
    }
);
export default service;
